
class GhTestimonialSwiper extends HTMLElement {

  constructor() {
    super();
    this.instance = null;
    this.init();
  }
  init() {
    const swiperRoot = this.querySelector(".swiper");
    if (!swiperRoot) return;

    const slideCount = this.querySelectorAll(".swiper-slide").length;
    if (slideCount <= 1) return;

    const autoplayEnabled = this.dataset.autoplay === "true";
    const delayMs = Math.max(3000, Number(this.dataset.cycleSpeed || 5) * 1000);

    this.instance = new Swiper(".gh-testimonial-carousel__swiper", {
      slidesPerView: 1.7,
      spaceBetween: 32,
      loop: true,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 30, 
        },
        0: {
          slidesPerView: 1,
          spaceBetween: 10, 
        },
      },
    });
  }
}

if (!window.customElements.get("gh-testimonial-swiper")) {
  window.customElements.define("gh-testimonial-swiper", GhTestimonialSwiper);
}
